import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TokenType {
  isLogin: boolean;
  isHydrated: Boolean;
  setIsHydrated: (state: Boolean) => void;
  token: string | null;
  ssid: string | null;
  setSsid: (ssid: string | null) => void;
  setToken: (token: string | null) => void;
}

export const useTokenStore = create<TokenType>()(
  persist(
    (set) => ({
      isLogin: false,
      token: null, // token || null
      ssid: null,
      setToken: (token) => set(() => ({ token, isLogin: !!token })),
      setSsid: (ssid) => set(() => ({ ssid })),
      isHydrated: false,
      setIsHydrated: (state) => set({ isHydrated: state }),
    }),
    {
      name: 'authToken',
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setIsHydrated(true);
        }
      },
    },
  ),
);
